import React from "react";

type Props = {
  children: React.ReactNode;
};

type State = {
  error: Error | null;
};

export class RootErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Root render failed:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, maxWidth: 640, margin: "40px auto", fontFamily: "system-ui, sans-serif" }}>
          <h1 style={{ fontSize: 18, marginBottom: 12 }}>Something went wrong</h1>
          <p style={{ color: "#666", marginBottom: 16 }}>
            The application could not start. Try reloading the page. If the problem persists, check the browser
            console or contact support.
          </p>
          <pre
            style={{
              fontSize: 12,
              overflow: "auto",
              padding: 12,
              background: "#f5f5f5",
              borderRadius: 4,
            }}
          >
            {this.state.error.message}
          </pre>
          <button type="button" onClick={() => window.location.reload()} style={{ marginTop: 16 }}>
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
